import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "test-scenarios row text-center d-flex justify-content-center" }
const _hoisted_2 = { class: "col-xl-3" }
const _hoisted_3 = { class: "icon mx-auto" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "col-xl-3 offset-xl-1" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "col-xl-3 offset-xl-1" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 0,
  class: "mt-4 mb-0 alert alert-success"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_composite_icon = _resolveComponent("composite-icon")!
  const _component_sub_section = _resolveComponent("sub-section")!

  return (_openBlock(), _createBlock(_component_sub_section, {
    title: "Everything you want after tax",
    helpTitle: "Everything you want after tax",
    helpText: _ctx.HelpText.everythingYouWant()
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_composite_icon, { icons: [ { icon: 'bi-circle', size: '3.5rem' }, { icon: 'bi-currency-pound', size: '2.2rem', top: '0.95rem', left: '0.63rem' } ] })
          ]),
          _createElementVNode("p", { innerHTML: _ctx.incomeText }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "icon mx-auto" }, [
            _createElementVNode("i", { class: "bi bi-percent mb-4" })
          ], -1)),
          (_ctx.showInflationText)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.inflationText), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "icon mx-auto" }, [
            _createElementVNode("i", { class: "bi bi-piggy-bank mb-4" })
          ], -1)),
          _createElementVNode("p", { innerHTML: _ctx.monthlyPotsContributionText }, null, 8, _hoisted_8)
        ])
      ]),
      (_ctx.showIncomeAdjustorResetWarning)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "bi bi-info-circle-fill me-2 fs-5" }, null, -1),
            _createTextVNode(" As some of your inputs have changed we have reset the level of income wanted and removed any guaranteed income if you added any. Please solve again if there are now shortfalls and/or re-add guaranteed income if you want some. ")
          ])))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["helpText"]))
}